// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"aafc4ca4","288":"6e22d13b","296":"10558086","442":"de23ea4c","789":"95a6dacb"}[chunkId] + ".chunk.css";
};